<script>
  import { Swipe, SwipeItem } from "svelte-swipe"; // gzipped 3.37 KB
  export let config = {};
  export let data = {};

  let autoplay = false;
  let delay = 2000; //ms
  let showIndicators = true;
  let transitionDuration = 400; //ms
  let defaultIndex = 0; //start from 0

</script>

<style>
  .swipe-holder{
    /* height: 30vh; */
    height: 540px;
    width: 100%;
    text-align: center;
  }
  img{
    max-width: 100%;
    height: auto;
    max-height: 500px;
  }
  @media (max-width: 959px) and (min-width: 600px) {
    .swipe-holder{
      height: 510px;
    }
    img{
      max-height: 470px;
    }
  }
  @media (min-width: 960px) {
    .swipe-holder{
      height: 520px;
    }
    img{
      max-height: 480px;
    }
  }
</style>

<div class="swipe-holder">
  <Swipe {showIndicators} {autoplay} {delay} {transitionDuration} {defaultIndex}>
    {#each data as slide, i}
    <SwipeItem>
      {#if slide.src }
      <img src={slide.src} alt={slide.alt} />
      {:else}
        <span>Slide {i} - {slide.src}</span>
      {/if}
    </SwipeItem>
    {/each}
    <!-- <SwipeItem>
      <img src="./images/1.jpg" alt="">
    </SwipeItem>

    <SwipeItem>
      <img src="./images/2.jpg" alt="">
    </SwipeItem>

    <SwipeItem>
      <img src="./images/3.jpg" alt="">
    </SwipeItem>

    <SwipeItem>
      <img src="./images/4.jpg" alt="">
    </SwipeItem> -->
  </Swipe>
</div>